import { Link } from "react-router-dom";

function simulationsUrl(value: string | undefined): string | null {
  if (!value) return null;
  try {
    const url = new URL(value);
    if (url.protocol !== "https:" || url.username || url.password) return null;
    return url.href;
  } catch {
    return null;
  }
}

export function AIOperationsMovedScreen() {
  const destination = simulationsUrl(import.meta.env.VITE_SONNY_SUPPORT_URL);
  return (
    <section className="flex flex-col items-start gap-15">
      <h1 className="type-heading-xl">AI Operations has moved</h1>
      <p className="type-body-md text-ink-muted">
        Simulations now lives in Sonny Support. Brain, Tools, and the other
        AI Operations pages are no longer available in the portal.
      </p>
      {destination ? (
        <a
          href={destination}
          rel="noreferrer"
          className="text-accent underline"
        >
          Open Sonny Support
        </a>
      ) : (
        <p className="type-body-md text-ink-muted">
          The Sonny Support address is not available yet.
        </p>
      )}
      <Link to="/admin" className="text-accent underline">
        Back to admin
      </Link>
    </section>
  );
}
